import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGSidebar} from "vgnav/src/VGSidebar";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.fixedHeader($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {
		//VG.load.aos();
	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.fixedHeader($self);
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] > img').each(function(){
				$(this).closest('a').attr('href', $(this).attr('src'));
			});
		});

		// вкл/выкл поля после смены переключателя
	/*	$(document).on('change', '[data-toggle="switch-disabled"]', function () {
			let $self = $(this),
				$container = $self.closest('.form-disabled'),
				$inputs = $container.find('.form-disabled-area input'),
				$radio = $container.find('input[type=radio]');

			$.each($radio, function () {
				let $_self = $(this);

				if ($_self.is(':checked')) {
					$inputs.attr('disabled', false);
				} else {
					$inputs.attr('disabled', true);
					$inputs.val('');
					$inputs.prop('checked', false);
				}
			});
		});*/
	},

	load: {
		aos: function () {
			$('.vg-page-default, .page-default').each(function () {
				let $self = $(this);

				if (enables.scrollAnimation) {
					if (typeof $self.attr('data-aos-start') !== undefined && $self.attr('data-aos-start') !== false) {
						let $tags = ['p', 'li', 'h2', 'h3'],
							start = parseInt($self.data('aos-start')),
							step = 100;

						for (let i = 1; i <= $tags.length; i++) {
							let tag = $tags[i - 1],
								$tag = $self.find(tag);

							if ($tag.length) {
								$.each($tag, function () {
									start = start + step;
									$(this).attr('data-aos', 'fade-up');
									$(this).attr('data-aos-delay', start);
								});
							}
						}

						AOS.init();
					}
				}
			});
		}
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableVGSidebar();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: '<i class="fa fa-chevron-down"></i>'
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function ()  {
			//$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie({
				privacyLink: '/privacy-policy'
			});
		},

		enableVGSidebar: function () {
			$(document).on('click', '[data-vg-toggle="sidebar"]', function () {
				let $_self = $(this),
					target = $_self.attr('href').substring(1),
					sidebarOption = {
						button: this,
						ajax: {
							target: this.dataset.ajaxTarget || "",
							route: this.dataset.ajaxRoute || ""
						}
					};

				const $sidebar = new VGSidebar(target, sidebarOption);

				if ($_self.hasClass('vg-sidebar-active')) {
					$sidebar.close();
				} else {
					$sidebar.open();

					let $form = $('#form-cart');
					$form.find('[data-cart-block="form"]').hide();
					$form.find('[data-cart-block="all-products"]').show();

					$form.find('.vg-sidebar-back').hide();
					$form.find('.vg-sidebar-title').text('Ваш заказ');
				}

				return false;
			});
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.header-wrapper'),
			scroll = $self.scrollTop(),
			$body = $('body');

		if (scroll > 0) {
			$body.addClass('header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('header--is-fixed');
		}

		// widgets-sticky scroll
		let $widgetsSticky = $('.widgets-sticky, .sticky-top');
		if ($widgetsSticky.length) {
			if($body.hasClass('header--is-fixed')) {
				$widgetsSticky.css('top', 105);
			} else {
				$widgetsSticky.css('top', 0);
			}
		}
	},
}


export default VGListener;
